import type { FaireProductEntity } from "../../entity_types/product";

export const p_am28x7tpli: FaireProductEntity = {
  token: "p_am28x7tpli",
  type: "product",
  name: "Glowing Guatemala 100% Cacao - Organic Ceremonial Chocolate",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/5a4bb9bd046d8d1825fcf89daabc7321dead19403188a8ae1d484f4e44ede2d1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/36762e16774f17cad92aa4dc860c1e3f227bef252b9d2c48171c45c501549d65.png",
    "https://cdn.faire.com/fastly/1f747abb235ee5e0715737b342f0dbf39252528a60e39453e42c7a02edc40e90.png",
    "https://cdn.faire.com/fastly/064b94bd5eebe080422e6cf3161eab913ac1ddb843f17e65b665820a859e8621.png",
    "https://cdn.faire.com/fastly/0e3a3ead89848472281f74ea0dba11bc60b6666e9114bdadd7531da7d04dea6e.jpeg",
    "https://cdn.faire.com/fastly/3f63e064d6b934b03ecf10491ef92e815c23bf403cf522bb1847404e0793bdf9.jpeg",
    "https://cdn.faire.com/fastly/cd35e1856d61de8574a9ef25a08f97ef8b025780f927fe64f085758ed6f06bdf.jpeg",
    "https://cdn.faire.com/fastly/96199480478c06b57ec2976743f2dccabb66fa7c390d8f72a6be6bae36f1e467.jpeg",
  ],
  priceDollars: 19.8,
  description:
    "Grown in the K’eqchi Mayalands, this cacao carries with it a strong, wise, yet graceful and mothering energy. It is perfect for a daily ritual of connection to self and when shared with community, activates our awareness to our inextricable connection to each other.\n\nThis cacao is grown in a remote village of 125 families located in the Alta Verapaz department - known as the mountains of True Peace. Their village is disconnected from the rest of the world except for a footbridge crossing the raging Cahabón river, and because of this, are still very much connected to their indigenous traditions as they have been able to resist outside influence. Thanks to this, their cacao traditions have remained intact and we have had the honor to learn directly from them during our in-person visits. The Indigenous families we work with make 90% of their income from cacao!\n\nMakes a great coffee replacement!\nFor dark chocolate lovers.\nLab tested for heavy metals safety.\nHigh flavanol / flavonoid.",
  tags: [],
  msrpDollars: 33,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:49.190Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
